<template>
	<div class="member-list-item horizontal-center">
		<div class="left">
			<common-avatar
				:staffId="staffId"
				:teamId="teamId"
				:image="image"
				:width="55"
				:name="name"
				:isTeam="isTeam"
			></common-avatar>
		</div>

		<div class="name bold18 ml-20" @click="onItemClick">{{ name }}</div>

		<div class="right" :style="rightStyle">
			<slot/>
		</div>
	</div>
</template>

<style lang="scss">
.member-list-item {
	background: #fff;
	justify-content: flex-start;

	.left {
		min-width: 75px;
	}

	.common-avatar .avatar img {
		margin: 0 0 0 auto !important;
	}

	.common-avatar,
	.name {
		padding: 8px 0;
	}

	.name {
		flex-grow: 1;
	}
}
</style>

<script>
import CommonAvatar from '@/components/CommonAvatar'

export default {
	name: 'MemberListItem',
	components: {
		CommonAvatar,
	},
	props: {
		name: {
			type: String,
			default: '',
		},
		image: {
			type: String,
			default: '',
		},
		staffId: {
			type: String,
			default: '',
		},
		teamId: {
			type: String,
			default: '',
		},
		isTeam: {
			type: Boolean,
			default: false,
		},
		isRightNoPadding: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
		}
	},
	mounted() {
	},
	computed: {
		rightStyle: function() {
			let style = {
				'padding': '8px 20px 8px 0',
			};
			return !this.isRightNoPadding ? style : '';
		},
	},
	methods: {
		onItemClick: function() {
			this.$emit('item-click');
		},
	},
}
</script>
